
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-password",
      function () {
        return require("private-next-pages/forgot-password/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forgot-password"])
      });
    }
  